import { Select, SelectItem } from "@mantine/core";
import { FC, ReactNode, useState } from "react";

export interface BSelectProps {
  data: (string | SelectItem)[];
  required?: boolean;
  onChange?: (value: string | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
  label?: ReactNode;
  description?: ReactNode;
  placeholder?: string;
  disabled?: boolean;
  nothingFound?: ReactNode;
  readOnly?: boolean;
  clearable?: boolean;
  allowDeselect?: boolean;
  limit?: number | null;
  filter?: (value: string, item: SelectItem) => boolean;
  itemComponent?: FC<any>;
}

export const BSelect = ({
  data,
  required,
  onChange,
  error,
  value,
  disabled,
  label,
  description,
  placeholder,
  nothingFound,
  readOnly,
  limit,
  filter,
  itemComponent,
  clearable,
  allowDeselect,
}: BSelectProps) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>(value);

  const onSelectChange = (value: string | undefined) => {
    onChange && onChange(value);
    setSelectedValue(value);
  };

  return (
    <Select
      withinPortal
      disabled={disabled}
      required={required}
      error={error}
      label={label}
      limit={limit === null ? undefined : limit === undefined ? 20 : limit}
      description={description}
      placeholder={placeholder}
      searchable
      clearable={required ? false : clearable}
      allowDeselect={required ? false : allowDeselect}
      onChange={(v) => {
        v ? onSelectChange(v) : onSelectChange(undefined);
      }}
      value={selectedValue ?? null}
      nothingFound={nothingFound}
      readOnly={readOnly}
      filter={filter}
      itemComponent={itemComponent}
      data={data}
    />
  );
};
